import { createFileRoute } from "@tanstack/react-router";

// Route definition stays eager (zero-cost — just metadata). The actual
// component lives in `usage.lazy.tsx` so recharts and its dependents
// only land in the bundle when the user navigates here.
export const Route = createFileRoute("/app/projects/$pid/usage")({});
